import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import AutorizacionActions from "../../../stores/autorizacion/Actions";
import { useMountEffect, useUpdateEffect } from "../../../hooks/LifeCycle";
import BusquedaAutorizacionForm from "../components/BusquedaAutorizacionForm";
import CustomTable from "../../../components/CustomTable/CustomTable";
import CustomLayout from "../../../components/CustomLayout/CustomLayout";
import TittleLine from "../../../components/Common/TittleLine";
import { Section } from "../../../components/CustomLayout/CustomLayoutStyles";
import { isObjectEmpty } from "../../../utils/ObjectUtil";
import CustomAlert from "../../../components/Common/CustomAlert";
import { mostrarErrorGenerico } from "../../../utils/AlertUtils";
import CheckRender from "../../../components/Common/CheckRender";
import useEmpresa from "../../../hooks/useEmpresa";
import {
  columnsBusquedaAutorizaciones,
  ESTADO_AUTORIZACION,
} from "../utils/AutorizacionConstant";
import ModalLoader from "../../../components/Common/ModalLoader";
import moment from "moment";
import { DATE_FORMATS, QUERY_RANGE, TIME_SCALE } from "../../../utils/Constant";
import { camposCompletos } from "../../../utils/ValidationUtil";
import { ALERTAS_GENERICAS } from "../../../utils/AlertasGenericas";
import Pagination from "../../../components/CustomTable/Pagination";
import CustomSeparator from "../../../components/Common/CustomSeparator";

const BusquedaAutorizacionScreen = (props) => {
  const [formData, setFormData] = useState({
    numeroBusqueda: "",
    fechaInicio: "",
    fechaFin: "",
  });

  const history = useHistory();

  const empresa = useEmpresa();

  const [showAlert, setShowAlert] = useState(false);

  const [alertConfig, setAlertConfig] = useState({});

  const [processing, setProcessing] = useState(false);

  const itemsPerPage = 10;

  const [currentPage, setCurrentPage] = useState(1);

  const [autorizaciones, setAutorizaciones] = useState([]);

  const [totalRegistros, setTotalRegistros] = useState(0);

  useMountEffect(() => {
    let startDate = moment(new Date())
      .subtract(QUERY_RANGE.uno, TIME_SCALE.dia)
      .format(DATE_FORMATS.middledash_ymd);

    let today = moment(new Date()).format(DATE_FORMATS.middledash_ymd);

    setFormData((prevState) => {
      return {
        ...prevState,
        fechaInicio: startDate,
        fechaFin: today,
      };
    });
  });

  /**
   * Consultar autorizaciones Success.
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.consultarAutorizacionesData) && processing) {
      setProcessing(false);

      setAutorizaciones(
        props?.consultarAutorizacionesData?.autorizaciones || []
      );

      setTotalRegistros(props?.consultarAutorizacionesData?.paginacion?.totalRegistros);
    }
  }, [props.consultarAutorizacionesData]);

  /**
   * Consultar autorizaciones Error.
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.consultarAutorizacionesError) && processing) {
      setProcessing(false);

      setAutorizaciones([]);

      mostrarErrorGenerico(
        props?.consultarAutorizacionesError,
        setProcessing,
        setAlertConfig,
        setShowAlert
      );
    }
  }, [props.consultarAutorizacionesError]);

  /**
   * Cancelar autorizacion Success.
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.cancelarAutorizacionData) && processing) {
      setProcessing(false);

      setAutorizaciones(
        autorizaciones.map((autorizacion) => {
          if (
            autorizacion.key ===
            props?.cancelarAutorizacionData?.autorizacion?.key
          ) {
            return {
              ...autorizacion,
              descripcionEstatus: ESTADO_AUTORIZACION.CANCELADO,
            };
          }
          return autorizacion;
        })
      );

      setAlertConfig({
        type: "success",
        title: `Autorización ${props?.cancelarAutorizacionData?.autorizacion?.numeroAutorizacion} cancelada con éxito!`,
        onConfirm: () => {
          setShowAlert(false);
        },
      });
      setShowAlert(true);
    }
  }, [props.cancelarAutorizacionData]);

  /**
   * Cancelar autorizacion Error.
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.cancelarAutorizacionError) && processing) {
      setProcessing(false);
      mostrarErrorGenerico(
        props?.cancelarAutorizacionError,
        setProcessing,
        setAlertConfig,
        setShowAlert
      );
    }
  }, [props.cancelarAutorizacionError]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    buscarAutorizaciones(page);
  };

  const showModalLoader = () => {
    const { consultarAutorizacionesLoading, cancelarAutorizacionLoading } =
      props;

    return consultarAutorizacionesLoading || cancelarAutorizacionLoading;
  };

  const cancelarAutorizacion = (record) => {
    if (record?.descripcionEstatus === ESTADO_AUTORIZACION.CANCELADO) {
      return;
    }

    const { numeroSesionReutilizable } = props?.authUserData;

    let mensaje = `¿Deseas cancelar la autorización ${record?.numeroAutorizacion}?`;

    if (record?.numeroAutorizacionMadre) {
      mensaje = 'Esta autorización pertenece a un Plan Suplementario. Al cancelarla se cancelarán las autorizaciones que estén vinculadas a esta.';
    }

    setAlertConfig({
      type: "confirm",
      title: "¿Estás seguro?",
      message: mensaje,
      onConfirm: () => {
        setProcessing(true);
        props.cancelarAutorizacion({
          numeroSesion: numeroSesionReutilizable,
          autorizacion: record,
        });

        setShowAlert(false);
      },
      onCancel: () => {
        setShowAlert(false);
      },
    });
    setShowAlert(true);
  };

  const verDetalleAutorizacion = (record) => {
    history.push({
      pathname: "/detalle-autorizacion",
      state: {
        autorizacion: {
          numeroAutorizacion: record?.numeroAutorizacion,
          ano: moment(record?.fechaServicio).year(),
        },
        desdePantallaConsulta: true
      },
    });
  };

  const onStateChange =
    (key, format = null) =>
    (value) => {
      setFormData((prevState) => {
        return {
          ...prevState,
          [key]: format ? format(value) : value,
        };
      });
    };

  const buscarAutorizaciones = (pagina) => {
    const { fechaInicio, fechaFin } = formData;

    let mensajeValidacion = null;

    if (!camposCompletos({ fechaInicio, fechaFin })) {
      mensajeValidacion = ALERTAS_GENERICAS.CAMPOS_REQUERIDOS;
    } else if (moment(fechaInicio).isAfter(fechaFin)) {
      mensajeValidacion = ALERTAS_GENERICAS.FECHA_DESDE_HASTA_INVALIDA;
    }

    if (mensajeValidacion) {
      setAlertConfig({
        type: "info",
        title: "¡Hola!",
        message: mensajeValidacion,
        onConfirm: () => {
          setShowAlert(false);
        },
      });
      setShowAlert(true);
      return;
    }

    setProcessing(true);

    props.consultarAutorizaciones({
      ...formData,
      prefijo: empresa?.PREFIJO_AUTORIZACION,
      compania: empresa?.CODIGO,
      pagina: pagina,
      tamanoPagina: itemsPerPage,
    });
  };

  return (
    <CustomLayout
      showMenuNav={true}
      footerPosition={autorizaciones?.length > 0 ? "relative" : "fixed"}
    >
      <Section>
        <TittleLine title={"Búsqueda avanzada"} weight={"bold"} />
      </Section>

      <Section>
        <BusquedaAutorizacionForm
          {...formData}
          onStateChange={onStateChange}
          onSearch={() => buscarAutorizaciones(currentPage)}
          isLoading={props.consultarAutorizacionesLoading}
        />
      </Section>

      <Section>
        <CustomTable
          columns={columnsBusquedaAutorizaciones(
            cancelarAutorizacion,
            verDetalleAutorizacion,
            empresa
          )}
          dataSource={autorizaciones}
          showPagination={false}
          pageSize={itemsPerPage}
          width={"200%"}
        />
      </Section>
      <CustomSeparator height={"20px"} />
      <Section>
        <Pagination
          currentPage={currentPage}
          itemsPerPage={itemsPerPage}
          totalItems={totalRegistros}
          onPageChange={handlePageChange}
        />
      </Section>

      <CheckRender allowed={showModalLoader()}>
        <ModalLoader />
      </CheckRender>

      <CheckRender allowed={showAlert}>
        <CustomAlert {...alertConfig} />
      </CheckRender>
    </CustomLayout>
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  authUserLoading: state.auth.authUserLoading,
  authUserError: state.auth.authUserError,

  consultarAutorizacionesData: state.autorizacion.consultarAutorizacionesData,
  consultarAutorizacionesLoading:
    state.autorizacion.consultarAutorizacionesLoading,
  consultarAutorizacionesError: state.autorizacion.consultarAutorizacionesError,

  cancelarAutorizacionData: state.autorizacion.cancelarAutorizacionData,
  cancelarAutorizacionLoading: state.autorizacion.cancelarAutorizacionLoading,
  cancelarAutorizacionError: state.autorizacion.cancelarAutorizacionError,
});

const mapDispatchToProps = {
  consultarAutorizaciones: AutorizacionActions.consultarAutorizaciones,
  cancelarAutorizacion: AutorizacionActions.cancelarAutorizacion,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(BusquedaAutorizacionScreen);
